/**
 * @file 存放数据常量
 */

export const Bridge = {
  "ea53bb2e-19ff-4c30-8dcf-f915e8ddfc81": {
    basePath: "jiajiang", // 大桥base基础路径
    name: "南京夹江大桥", //  大桥名称
    className: "bridge-jiajiang", //  大桥列表页的class名称
    indexUrl: "jiajiangIndex", // 大桥首页URL
  },
  "7553a665-0928-4416-9389-98e7cda26f0c": {
    basePath: "qingShui",
    name: "贵州清水河大桥",
    className: "bridge-qingshui",
    indexUrl: "qingShuiIndex",
  },
  "033d2279-bc46-40de-901e-f885acda440c": {
    basePath: "nansi",
    name: "南京四桥",
    className: "bridge-nanjinsiqiao",
    indexUrl: "nansiIndex",
  },
  "2003ac27-8590-4b54-9022-0a9c92e809c7": {
    basePath: "qipanzhou",
    name: "棋盘州大桥",
    className: "bridge-qipanzhou",
    indexUrl: "qipanzhouIndex",
  },
  "ad0ff0a3-ca71-42a1-b99a-e031e7d5dffd": {
    basePath: "tls",
    name: "综合测试桥",
    className: "",
    indexUrl: "",
  },
  "ffaa13fe-473e-4827-a8fd-b89b8fdd3899": {
    basePath: "niZhou",
    name: "南沙大桥坭洲水道桥",
    className: "bridge-nanshadaqiao",
    indexUrl: "niZhouIndex",
  },
  "ca2d3e5e-817b-4559-9eaf-06416bb02ed2": {
    basePath: "",
    name: "西江大桥",
    className: "",
    indexUrl: "",
  },
  "12d3dd46-152d-4fae-8b24-84dca74c4ce8": {
    basePath: "daSha",
    name: "南沙大桥大沙水道桥",
    className: "bridge-dashashui",
    indexUrl: "daShaIndex",
  },
  "ca6d55dc-e059-4d72-b494-e3140e31b2fe": {
    basePath: "sutong",
    name: "苏通大桥",
    className: "bridge-sutong",
    indexUrl: "sutongIndex",
  },
  "6d4fb3aa-85a9-46d4-9d45-29dd40c08fe8": {
    basePath: "humen",
    name: "虎门大桥",
    className: "",
    indexUrl: "",
  },
  "af4efd47-4bf0-4ce4-b484-0003c5726b91": {
    basePath: "hangzhouwan",
    name: "杭州湾大桥",
    className: "bridge-hangzhouwan",
    indexUrl: "hangzhouwanIndex",
  },
  "09bbc800-31db-43c4-aa1c-5b941fae5641": {
    basePath: "liede",
    name: "猎德大桥",
    className: "bridge-liede",
    indexUrl: "liedeIndex",
  },
  "8c363c2c-8e86-499d-80a5-b3718fd4b102": {
    basePath: "jiangshun",
    name: "江顺大桥",
    className: "bridge-jiangshun",
    indexUrl: "jiangshunIndex",
  },
  "385a98d3-6767-4f7b-9974-d219e41a4226": {
    basePath: "yueqingwan",
    name: "乐清湾大桥",
    className: "bridge-yueqingwan",
    indexUrl: "yueqingwanIndex",
  },
  "5afe37e8-98fc-416c-b5e3-26011df7fb39": {
    basePath: "jinshajiang",
    name: "金沙江大桥",
    className: "bridge-jinshajiang",
    indexUrl: "jinshajiangIndex",
  },
  "d9947c5e-0ba6-43ad-bd1b-e9d9bc50ee90": {
    basePath: "guizhouInspectGroup",
    name: "贵州专项检测组桥",
    className: "bridge-guizhouInspectGroup",
    indexUrl: "guizhouInspectGroupIndex",
  },
  "3aeeb5b1-f586-43c4-b03c-2e5880d2e541": {
    basePath: "xihoumenSensor",
    name: "西堠门大桥无线传感器",
    className: "bridge-xihoumen-sensor",
    indexUrl: "xihoumenSensorIndex",
  },
  "c6c66f8a-3738-4cfa-91b0-c4e18de7ff71": {
    basePath: "xihoumenFreshAir",
    name: "西堠门大桥新风系统",
    className: "bridge-xihoumen-fresh-air",
    indexUrl: "xihoumenFreshAirIndex",
  },
  "3d146b59-1bc6-4e89-8aa1-288e50929cbc": {
    basePath: "xihoumen",
    name: "西堠门大桥",
    // className: 'bridge-xihoumen-sensor',
    // indexUrl: 'xihoumenIndex',
    className: "",
    indexUrl: "",
  },
  "6edcfe29-44ab-44c6-88b0-0f67c021a553": {
    basePath: "balingheSensor",
    name: "贵州坝陵河大桥",
    className: "bridge-balinghe-sensor",
    indexUrl: "balingheSensorIndex",
  },
  "fe983c4c-7e10-4ccf-8099-fa0530b1da68": {
    basePath: "aipuruiInspectGroup",
    name: "艾普瑞专项检测组桥",
    className: "bridge-aipuruiInspectGroup",
    indexUrl: "aipuruiInspectGroupIndex",
  },
  "f917c90d-e6bd-484f-9311-bbe0fcf458e9": {
    basePath: "jiashaoCableTest",
    name: "嘉绍斜拉索试验",
    className: "bridge-jiashao",
    indexUrl: "jiashaoCableTestIndex",
  },
  "3b04991c-3662-4948-930e-ac537ed82fd3": {
    basePath: "jiashao",
    name: "嘉绍大桥",
    className: "bridge-jiashao",
    indexUrl: "jiashaoIndex",
  },
  "a89de080-e7dd-4c08-9298-0e3357cb9e4c": {
    basePath: "aizhai",
    name: "矮寨大桥",
    className: "bridge-aizhai",
    indexUrl: "aizhaiIndex",
  },
  "7c94a3ff-3eaa-4965-8314-56422f799331": {
    basePath: "beipanjiang",
    name: "北盘江大桥",
    className: "bridge-beipanjiang",
    indexUrl: "beipanjiangIndex",
  },
  "c9d48318-33b3-4042-8fd4-54bec55465ed": {
    basePath: "yichang",
    name: "宜昌大桥",
    className: "bridge-yichang",
    indexUrl: "yichangIndex",
  },
  "60eec124-a7bd-41e9-bbbc-a957cdcf7fda": {
    basePath: "huangpu",
    name: "黄埔大桥",
    className: "",
    indexUrl: "",
  },
  "9dccd8be-62c1-4422-93b1-1d5c02703b87": {
    basePath: "weather",
    name: "主要城市天气",
    className: "",
    indexUrl: "",
  },
  "077b2024-c60f-4f34-80f9-467bb24cc324": {
    basePath: "averageAnalysis", 
    name: "时均数据分析桥", 
    className: "bridge-averageAnalysis", 
    indexUrl: "averageAnalysisIndex", 
  },
};

export const BridgeBasePath = ["jiajiang", "qingShui", "niZhou", "daSha", "sutong"];

export const loginAesSecret = "edBeb93c0ef447eBab5d44eF725ae51A";

export const historyDataCountOptions = [
  { label: 6, value: 6 },
  { label: 10, value: 10 },
  { label: 12, value: 12 },
  { label: 20, value: 20 },
  { label: 24, value: 24 },
  { label: 30, value: 30 },
  { label: 40, value: 40 },
  { label: 48, value: 48 },
  { label: 50, value: 50 },
  { label: 60, value: 60 },
  { label: 90, value: 90 },
  { label: 100, value: 100 },
  { label: 120, value: 120 },
  { label: 150, value: 150 },
  { label: 180, value: 180 },
  { label: 200, value: 200 },
  { label: 210, value: 210 },
  { label: 240, value: 240 },
  { label: 270, value: 270 },
  { label: 300, value: 300 },
  { label: 330, value: 330 },
  { label: 365, value: 365 },
  { label: 500, value: 500 },
  { label: 720, value: 720 },
  { label: 1000, value: 1000 },
  { label: 1440, value: 1440 },
  { label: 1500, value: 1500 },
  { label: 2000, value: 2000 },
  { label: 4000, value: 4000 },
  { label: 6000, value: 6000 },
  // { label: 4380, value: 4380 },
  // { label: 8760, value: 8760 },
  // { label: 17760, value: 17760 },
];
